// 注册自定义指令（目前包含v-animate动画指令）
import Vue from 'vue'
import animate from '../directives/animate'

// v-animate：为元素添加animate.css动画，支持动态动画名
Vue.directive('animate', animate)
